module.exports = __webpack_public_path__ + "img/W-G08.7f47ba6c.jpg";